import React from 'react';

import styles from './ErrorPage.module.css';

function ErrorPage() {
  return (
    <div className={styles.mainError}>
      <span>Oops! Something went wrong</span>
    </div>
  );
}

export default ErrorPage;
